import { cn } from '../../shared/cn';
import { Button } from './button';

export interface SegmentedOption<T extends string> {
  readonly id: T;
  readonly label: string;
}

export function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
  className,
}: {
  readonly value: T;
  readonly options: readonly SegmentedOption<T>[];
  readonly onChange: (value: T) => void;
  readonly ariaLabel: string;
  readonly className?: string;
}) {
  return (
    <div className={cn('flex w-full flex-wrap gap-1 rounded-md border border-[#d6ded0] bg-[#fbfcfa] p-1 sm:w-auto', className)} role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <Button
          key={option.id}
          type="button"
          variant={value === option.id ? 'primary' : 'ghost'}
          className="min-w-0 flex-[1_1_8rem] whitespace-normal px-3 text-xs"
          onClick={() => onChange(option.id)}
          aria-pressed={value === option.id}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
